/**
 * @fileoverview createObjArrandamiento
 * @version 2.0
 * @author Carlos Emilio Blanco Lopez
 * @date 2022
 * @update 22/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */

import { Result } from 'antd';
import {
    PersonaFisica,
    PersonaMoral,
    DataState,
    DataResponse,
    CreditObjCotizacion,
    LeasingObjCotizacion
} from '../interfaces/commonInterfaces';

let DataPersonaFisica: PersonaFisica;
let DataPersonaMoral: PersonaMoral;
/**
 * Function para la creacion del JSON para solicitud Buro Credito
 * @param dataCotizador 
 * @param dataResponse 
 * @returns Object
 */

export function createObjArrendamiento(dataCotizador: DataState, dataResponse: DataResponse, seguro?: number ): object {
    const data: "ResidualEstandar" | "ResidualMaximo" | "ResidualMinimo" | "_" = dataCotizador.purchaseOption;
    const residual = dataCotizador.purchaseOption === "_" ? "No element" : dataResponse.ObjCanalArrendamiento[dataCotizador.userPlazo][data];
    const hash = dataCotizador.unipadHash || '';
    console.log(residual);
    let dataAvalColony =dataCotizador.AvalObjColonias.filter(items => +items.id === +dataCotizador.avalColony)[0];
    let dataUserColony =dataCotizador.UserObjColonias.filter(items => +items.id === +dataCotizador.userColony)[0];
    /** Create Object Cotizacion  */
    const CreditDataCotizacion: CreditObjCotizacion = {
        plazo: dataCotizador.plazo,
        credito: Number(dataCotizador.credit),
        productType: dataCotizador.productTypeOption,
        tasa: dataCotizador.tasa,
        payment: dataCotizador.payment,
        quoteType: 5,
    };

    const LeasingObjCotizacion: LeasingObjCotizacion = {
        isPyME: dataResponse.filteredObjActivo.some(
            (item) => item.id === dataCotizador.userActivo && item.IsForPyme === true
          ) ? true : false,
        assetType: dataCotizador.userActivo,
        anticipoRenta: dataResponse.LeasingResultCotizacion.AdvanceRent,
        otrosGastos: 0,
        accesorios: 0,
        price: dataCotizador.assetPrice,
        garantia: 0,
        seguro: 0,
        residual: dataCotizador.purchaseOption === "ResidualMinimo" ? 1 : dataCotizador.purchaseOption === "ResidualEstandar" ? 2 : dataCotizador.purchaseOption === "ResidualMaximo" ? 3: 1,
        plazo: dataCotizador.plazo,
        comision: 3,
        gps: false,
        admon: 0,
        equipoAliado: 0,
        financiado: false,
        depositoGarantia: 0,
        margen: dataResponse.LeasingRentMargin,
        residualNominal: +residual,
        porcentajeComision: 0,
        brandCatalogId: 0,
        modelId: 0,
        version: "",
        año: 0,
        originador: 0,
        otroOriginador: false,
        diasRentaProporcional: 0,
        iva: 1,
        ivaRentas: 1,
        tipoResidual: dataCotizador.purchaseOption === "ResidualMinimo" ? 1 : dataCotizador.purchaseOption === "ResidualEstandar" ? 2 : dataCotizador.purchaseOption === "ResidualMaximo" ? 3: 1,
        depositRent: 0,
        pagoMensual: 0,
        anticipo: dataResponse.LeasingResultCotizacion.AdvanceCommision
    }

    let representativeFullName = '';

    if (dataCotizador.legalRepresentativeSecondName !== '') {
        representativeFullName =  dataCotizador.legalRepresentativeFirstName + ' ' + dataCotizador.legalRepresentativeSecondName
    }
    else {
        representativeFullName = dataCotizador.legalRepresentativeFirstName.trim()
    }
   
    /** Create Object  DataUser*/
    if (dataCotizador.userType === 1) {
        DataPersonaFisica = {
            secondName: dataCotizador.userSecondName,
            motherLastName: dataCotizador.userSecondLastName,
            fatherLastName: dataCotizador.userFirstLastName,
            firstName: dataCotizador.userFirstName,
            gender: dataCotizador.userGender,
            email: dataCotizador.userEmail,
            rfc: dataCotizador.userRFC,
            cellphone: dataCotizador.userCellphone,
            postalCode: dataCotizador.userCP,
            stateName: dataCotizador.userState,
            municipality: dataCotizador.userMunicipality,
            ingresosPromedio: dataCotizador.revenueMonthlyAverage,
            gastoMensual: dataCotizador.revenueMonthlyExpense,
            fechaInicioActividad: dataCotizador.revenueInitialDate,
            solidezEmpleador: 1,
            nivelEspecializacion: 1,
            principalMercado: dataCotizador.revenueFountain,
            porcentajeMercado: dataCotizador.revenuePercentage,
            concentracionClientes: dataCotizador.revenueCustomerConcentration,
            asalariado: true,
            aval: false
        };
    }
    else {
        DataPersonaMoral = {
            name: dataCotizador.userEnterprise,
            rfc: dataCotizador.userRFC,
            cellphone: dataCotizador.userCellphone,
            email: dataCotizador.legalRepresentativeEmail,
            postalCode: dataCotizador.userCP,
            stateName: dataCotizador.userState,
            municipality: dataCotizador.userMunicipality,
            representativeName: representativeFullName,
            representativeLastName: dataCotizador.legalRepresentativeFirstLastName,
            representativeSecondLastName: dataCotizador.legalRepresentativeSecondLastName,
            representativeEmail: dataCotizador.legalRepresentativeEmail,
            representativePhoneNumber: dataCotizador.legalRepresentativeCellphone,
        };
        DataPersonaFisica = {
            firstName: dataCotizador.avalFirstName,
            secondName: dataCotizador.avalSecondName,
            fatherLastName: dataCotizador.avalFirstLastName,
            motherLastName: dataCotizador.avalSecondLastName,
            gender: dataCotizador.avalGender,
            email: dataCotizador.avalEmail,
            rfc: dataCotizador.avalRFC,
            cellphone: dataCotizador.avalCellphone,
            postalCode: dataCotizador.avalCP,
            stateName: dataCotizador.avalState,
            municipality: dataCotizador.avalMunicipality,
            ingresosPromedio: dataCotizador.revenueMonthlyAverage,
            gastoMensual: dataCotizador.revenueMonthlyExpense,
            fechaInicioActividad: dataCotizador.revenueInitialDate,
            solidezEmpleador: 1,
            nivelEspecializacion: 1,
            principalMercado: dataCotizador.revenueFountain,
            porcentajeMercado: dataCotizador.revenuePercentage,
            concentracionClientes: dataCotizador.revenueCustomerConcentration,
            asalariado: true,
            aval: false
        };
    }

    let objResult: object = {};

    if(dataCotizador.quoteType === 0){
        if (dataCotizador.userType === 1 ) {
            objResult = {
                quotation: LeasingObjCotizacion,
                ekatena_ReportId: dataCotizador.ekatenaId,
                byEmail: dataCotizador.byEmail,
                ContactMethod: dataCotizador.userContactMethod,
                physicPersons: [DataPersonaFisica],
                originChannelId: 3,
            }
        } else {
            objResult = {
                quotation: LeasingObjCotizacion,
                byEmail: dataCotizador.byEmail,
                ContactMethod: dataCotizador.userContactMethod,
                ekatena_ReportId: dataCotizador.ekatenaId,
                legalPersons: [DataPersonaMoral],
                physicPersons: [DataPersonaFisica],
                originChannelId: 3,
            }
        }
    }else if(dataCotizador.quoteType === 1){
        if (dataCotizador.userType === 1 ) {
            objResult = {
                quotation: CreditDataCotizacion,
                ekatena_ReportId: dataCotizador.ekatenaId,
                byEmail: dataCotizador.byEmail,
                ContactMethod: dataCotizador.userContactMethod,
                physicPersons: [DataPersonaFisica],
                originChannelId: 3,
            }
        } else {
            objResult = {
                quotation: CreditDataCotizacion,
                byEmail: dataCotizador.byEmail,
                ekatena_ReportId: dataCotizador.ekatenaId,
                legalPersons: [DataPersonaMoral],
                physicPersons: [DataPersonaFisica],
                originChannelId: 3,
            }
        };
        
    }
    if (hash) {
    objResult = {
        ...objResult,
        hash
    };
}
    return objResult;
}